import { render, staticRenderFns } from "./fccGestaoArquivosCadastro.vue?vue&type=template&id=788429e0"
import script from "./fccGestaoArquivosCadastro.vue?vue&type=script&lang=js"
export * from "./fccGestaoArquivosCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports